import { forwardRef, useContext, useState } from "react";
import { AppBar, Box, Dialog, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { ModuleContext } from "../../context/ModuleContext";
import { ModuleContainer } from "../ModuleContainer";
import { AlternateAliasContext } from "../../context/AlternateAliasContext";
import { AlternateAliasDetailPanel } from "./AlternateAliasDetailPanel";
import { AlternateAliasOptionsMenu } from "./AlternateAliasOptionsMenu";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const AlternateAliasContainer = () => {
    const { aliasModule, setAliasModule } = useContext(AlternateAliasContext);

    const [module, setModule] = useState({
        isVisible: false,
        element: null,
        validated: false,
        validationError: null,
        userId: null,
        isLog: false,
    });

    const handleClose = () => {
        setAliasModule((prev) => ({ ...prev, isOpen: false }));
    };

    return (
        <Dialog fullScreen open={aliasModule.isOpen} TransitionComponent={Transition}>
            <ModuleContext.Provider value={{ module, setModule }}>
                <ModuleContainer />

                <AppBar sx={{ position: "relative", backgroundColor: "#A60F2D", color: "white" }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {"Alternate Alias: " + aliasModule.upn}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <Box sx={{ display: "flex", flexDirection: "row", p: 2, gap: 3, alignItems: "flex-start", flex: 1, minHeight: 0, overflowY: "auto" }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <AlternateAliasDetailPanel />
                    </Box>
                    {aliasModule.data !== null && (
                        <Box sx={{ flexShrink: 0 }}>
                            <AlternateAliasOptionsMenu />
                        </Box>
                    )}
                </Box>
            </ModuleContext.Provider>
        </Dialog>
    );
};